import type { EnumDeploymentRequestStatusV2Api, SearchFilterApi } from '@ingenico/api-sdk-device-management-private-v2';
import { enumDeploymentRequestStatusV2 } from '@ingenico/api-sdk-device-management-private-v2';
import type {
  AutocompleteQuickFilterOption,
  OverrideResetFieldType,
  QuickFilterDataToRefetchParams,
} from '@ingenico/react-ui/advanced-search';
import { DatagridQuickFilterResetType } from '@ingenico/react-ui/advanced-search';
import { toString } from 'lodash-es';
import { firstValueFrom } from 'rxjs';
import type { CoreError } from '../../../domain/api/mappers/coreErrorConstructor';
import type { DeviceManagementService } from '../../../domain/business/services/deviceManagement.service';

export function getOverrideResetFieldType(currentFiltersIndentifier: string[]): OverrideResetFieldType {
  return currentFiltersIndentifier.reduce(
    (accum, current) => ({ ...accum, [current]: DatagridQuickFilterResetType.FloatingButton }),
    {},
  );
}

export function getCategoryQuickFilterQuery(
  deviceManagementService: DeviceManagementService,
  params?: QuickFilterDataToRefetchParams,
  setIsLoading?: (isLoading: boolean) => void,
  setError?: (error?: CoreError) => void,
): Promise<AutocompleteQuickFilterOption[]> {
  const filters = params?.searchValue
    ? ([
        {
          filterType: 'fulltext',
          operator: 'equals',
          name: '',
          value: `*${toString(params?.searchValue)}*`,
        },
      ] as SearchFilterApi[])
    : ([] as SearchFilterApi[]);

  const request$ = deviceManagementService.getConfigurationProfilesForDeploymentRequest({
    filters,
    sort: {},
  });

  setIsLoading?.(true);
  setError?.();
  return firstValueFrom(request$)
    .then((response) => {
      return response.map((data) => ({ label: data.name, value: data.id }));
    })
    .finally(() => setIsLoading?.(false))
    .catch((error: CoreError) => {
      setError?.(error);
      return [];
    });
}

export function getStatusQuickFilterQuery(
  deviceManagementService: DeviceManagementService,
  translateStatus: (status: string) => string,
  setIsLoading?: (isLoading: boolean) => void,
  setError?: (error?: CoreError) => void,
): Promise<AutocompleteQuickFilterOption[]> {
  const request$ = deviceManagementService.getDeploymentUnitSearchFieldValues('deploymentUnit.status');

  setIsLoading?.(true);
  setError?.();
  return firstValueFrom(request$)
    .then((response) => {
      return response
        .filter((data) =>
          Object.values(enumDeploymentRequestStatusV2).includes(data as EnumDeploymentRequestStatusV2Api),
        )
        .map((data) => ({
          label: translateStatus(data),
          value: data,
        }));
    })
    .finally(() => setIsLoading?.(false))
    .catch((error: CoreError) => {
      setError?.(error);
      return [];
    });
}
